module.exports = __webpack_public_path__ + "static/media/auric-timber.2602700c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/assets/images/group logos/auric-timber.svg
// module id = 78
// module chunks = 0